import React from 'react';
import { Check, Gift } from 'lucide-react';
import { Section } from './Shared';
export const MethodOverview = () => {
  const tomos = [{
    color: 'bg-amber-100/40 border-amber-500/30',
    icon: '📘',
    title: 'TOMO I — Diagnóstico Energético',
    subtitle: 'Detectá qué tiene tu casa y dónde está el problema',
    outcome: 'Sabés exactamente qué limpiar y por qué.'
  }, {
    color: 'bg-emerald-100/40 border-emerald-500/30',
    icon: '📗',
    title: 'TOMO II — Limpieza y Sellado',
    subtitle: 'Aplicá el protocolo correcto para remover y sellar la energía',
    outcome: 'Tu hogar queda limpio y protegido.'
  }, {
    color: 'bg-orange-100/40 border-orange-500/30',
    icon: '📙',
    title: 'TOMO III — Blindaje Permanente',
    subtitle: 'Construí el sistema que sostiene la limpieza en el tiempo',
    outcome: 'La energía pesada no vuelve.'
  }];
  const checklist = ['Protocolo paso a paso listo para aplicar', 'Test de diagnóstico energético guiado', 'Técnicas con materiales accesibles (sal, hierbas, velas)', 'Modo Discreto para hogares con escépticos', 'Preguntas de cierre para cada sesión', 'Conexión entre tomos para un proceso secuencial', '100% diseñado para aplicar sin experiencia previa'];
  return <Section id="method" data-id="element-174">
      <div className="text-center mb-16" data-id="element-175">
        <div className="inline-flex items-center space-x-2 bg-brand-surface border border-brand-gold/30 px-4 py-1.5 rounded-full mb-6" data-id="element-176">
          <span className="text-xl" data-id="element-177">🌟</span>
          <span className="font-serif font-semibold tracking-wider text-brand-gold text-sm md:text-base" data-id="element-178">
            COLECCIÓN LUMEN AKASHA
          </span>
        </div>
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-179">
          3 Tomos + 2 Bonos — Sistema Completo de Limpieza Energética
        </h2>
        <p className="text-brand-muted text-[18px]" data-id="element-180">
          Del diagnóstico a la protección permanente. Todo resuelto.
        </p>
      </div>

      <h3 className="text-2xl font-serif font-bold text-center gold-gradient-text mb-[35px]" data-id="element-181">
        3 TOMOS COMPLETOS
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-182">
        {tomos.map((tomo, i) => <div key={i} className={`rounded-2xl p-6 md:p-8 border ${tomo.color} backdrop-blur-sm pt-[20px] pb-[20px] pl-[20px] pr-[20px]`} data-id="element-183">
            <div className="text-3xl mb-3" data-id="element-184">{tomo.icon}</div>
            <h4 className="font-serif font-bold mb-2 text-[15px]" data-id="element-185">
              {tomo.title}
            </h4>
            <p className="text-brand-gold/90 font-medium mb-4 text-[14px]" data-id="element-186">
              {tomo.subtitle}
            </p>
            <p className="text-brand-text/70 text-[12px]" data-id="element-187">
              <span className="font-bold text-brand-gold" data-id="element-188">→</span>{' '}
              {tomo.outcome}
            </p>
          </div>)}
      </div>

      <div className="glass-panel rounded-3xl p-8 md:p-12 max-w-3xl mx-auto pt-[30px] pb-[30px] pl-[30px] pr-[30px] mb-[90px]" data-id="element-189">
        <h4 className="text-xl font-serif font-bold mb-6 text-center" data-id="element-190">
          Cada tomo incluye:
        </h4>
        <ul className="space-y-4" data-id="element-191">
          {checklist.map((item, i) => <li key={i} className="flex items-start" data-id="element-192">
              <Check className="w-5 h-5 text-brand-gold mr-3 mt-0.5 shrink-0" data-id="element-193" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-194">{item}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center mb-12" data-id="element-195">
        <h3 className="md:text-4xl font-serif font-bold mb-4 text-[24px]" data-id="element-196">
          🎁 2 BONUS ESTRATÉGICOS
        </h3>
        <p className="text-brand-muted text-lg" data-id="element-197">
          Siempre incluidos. Siempre gratis.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-198">
        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden pt-[20px] pb-[20px] pl-[20px] pr-[20px]" data-id="element-199">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-200">
            GRATIS
          </div>
          <Gift className="w-8 h-8 text-brand-gold mb-3" data-id="element-201" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-202">
            BONUS 1 — Kit de Emergencia Energética
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-3" data-id="element-203">
            Protocolo rápido de 10 minutos para los días difíciles
          </p>
          <div className="text-sm" data-id="element-204">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-205">
              Valor: $5.000
            </span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-206">
              → GRATIS con tu pack
            </span>
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-6 border-brand-gold/30 relative overflow-hidden" data-id="element-207">
          <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-208">
            GRATIS
          </div>
          <Gift className="w-8 h-8 text-brand-gold mb-3" data-id="element-209" />
          <h4 className="text-xl font-serif font-bold mb-2" data-id="element-210">
            BONUS 2 — Planner de 30 Días
          </h4>
          <p className="text-brand-gold/90 text-sm font-medium mb-3" data-id="element-211">
            Calendario de mantenimiento para no perder la constancia
          </p>
          <div className="text-sm" data-id="element-212">
            <span className="line-through text-brand-text/50 mr-2" data-id="element-213">
              Valor: $5.000
            </span>{' '}
            <span className="text-brand-gold font-bold" data-id="element-214">
              → GRATIS con tu pack
            </span>
          </div>
        </div>
      </div>

      <div className="text-center mt-8" data-id="element-215">
        <p className="font-medium bg-brand-surfaceLight/50 inline-block px-6 py-3 rounded-full border border-brand-gold/20 text-[15px]" data-id="element-216">
          Valor total de los Bonus:{' '}
          <span className="line-through text-brand-text/50 mx-1 text-[12px]" data-id="element-217">
            $10.000
          </span>{' '}
          <span className="text-brand-gold font-bold" data-id="element-218">
            → GRATIS con tu Colección
          </span>
        </p>
      </div>
    </Section>;
};